import { render, staticRenderFns } from "./WomenReportWeekly.vue?vue&type=template&id=5a22f12a&scoped=true"
import script from "./WomenReportWeekly.vue?vue&type=script&lang=js"
export * from "./WomenReportWeekly.vue?vue&type=script&lang=js"
import style0 from "./WomenReportWeekly.vue?vue&type=style&index=0&id=5a22f12a&prod&scoped=true&lang=css"
import style1 from "./WomenReportWeekly.vue?vue&type=style&index=1&id=5a22f12a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22f12a",
  null
  
)

export default component.exports